import axios from 'axios';
import {
  ANALYS,
  GET_EQ_NAMES,
  GET_EQ_NAMES_BLOCK,
  GET_EQ_PARAMS,
  GET_EQ_PARAMS_BY_ID,
  LATEST_ENERGIES,
  RETRIEVE_EQ_PA_VALUES,
  RETRIEVE_EQ_PA_VALUES_V3,
} from './Apis';

export const analysis = () => {
  return axios.get(ANALYS);
};

export const getLatestEnergies = () => {
  return axios.get(LATEST_ENERGIES);
};

export const getEqPaValues = (body) => {
  return axios.post(RETRIEVE_EQ_PA_VALUES, body);
};
export const getEqPaValuesV3 = (body) => {
  // return axios.post(RETRIEVE_EQ_PA_VALUES_V3, body);
  return axios.post("/analysis/measurement/v3", body);
};
export const getTotalValues = (body) => {
  return axios.post(`/reports/equipmentParameterValues/total`, body);
  // return axios.post(`/analysis/measurement/total/v2`, body);
};
export const getTotalValuesV2 = (body) => {
  // return axios.post(`/reports/equipmentParameterValues/total/v2`, body);
  return axios.post(`/analysis/measurement/total/v2`, body);
};
export const getEqParams = (id) => {
  return axios.get(GET_EQ_PARAMS(id));
};
export const getStringParamByEquId = (id) => {
  return axios.get(`/equipments/${id}/parameters`);
};

export const getEqNamesBlock = (block) => {
  return axios.get(GET_EQ_NAMES_BLOCK(block));
};

export const getEqNames = (id) => {
  return axios.get(GET_EQ_NAMES(id));
};

export const getReports = (date) => {
  return axios.post(`/analysis/reports`, date);
};
export const getReportsv2 = (date) => {
  return axios.post(`/reports`, date);
};
export const getParameterCode = (info) => {
  return axios.post(`/parameters/parametersCode`, info);
};

export const getEqParamsById = (id) => {
  return axios.get(GET_EQ_PARAMS_BY_ID(id));
};
export const getEquipmentByParamId = (category, param) => {
  return axios.post(`/equipments/categories/${category}`, param);
};
export const getParameterByEQId = (param) => {
  return axios.post(`/parameter/equipments`, param);
};
export const getCategories = () => {
  return axios.get('/models/categories');
};

export const getGetAllDeviceByParameter = () => {
  return axios.get('/equipments/parameters');
};

export const getGetAllParameterByDevice = () => {
  return axios.get('/parameter/equipments');
};
export const addSwitchCondition = (param) => {
  return axios.post(`/deviceConditions`, param);
}
export const getAllSwitchCondition = () => {
  return axios.get(`/deviceConditions`);
}
export const editSwitchCondition = (id,param) => {
  return axios.put(`/deviceConditions/${id}`,param);
}
export const deleteSwitchCondition = (id) => {
  return axios.delete(`/deviceConditions/${id}`);
}
